var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-bar"},[_c('div',{staticClass:"loading-bar__progress",style:({transform: ("scaleX(" + _vm.progress + ") translateZ(0)")})}),_c('div',{staticClass:"loading-bar__effect"})])}
var staticRenderFns = []

export { render, staticRenderFns }